import { useAuthStore } from '@/stores/authStore.js'

export const fetchData = async (endpoint) => {
  const auth = useAuthStore()
  const apiUrl = import.meta.env.VITE_API_BASE_URL
  try {
    const response = await fetch(`${apiUrl}/${endpoint}`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    })
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    return await response.json()
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}

export const fetchDataInboxPlacement = async (endpoint) => {
  const auth = useAuthStore()
  const apiUrl = import.meta.env.VITE_API_BASE_URL_INBOX_PLACEMENT
  try {
    const response = await fetch(`${apiUrl}/${endpoint}`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    })
    if (!response.ok) {
      // Try to parse the response body for detailed error information
      let errorDetails: any = {}
      try {
        errorDetails = await response.json()
      } catch (parseError) {
        // If parsing fails, use default error details
        errorDetails = { message: response.statusText }
      }

      if (response.status === 400) {
        console.log('Bad Request: Please check your input.:', response)
        throw new Error('Bad Request: Please check your input.')
      } else if (response.status === 401) {
        throw new Error('Unauthorized: Please log in.')
      } else if (response.status === 403) {
        throw new Error('Forbidden: Access denied.')
      } else if (response.status === 429) {
        // Create a detailed error object with the response information
        const rateLimitError = new Error(errorDetails.message || 'Rate limit exceeded')
        ;(rateLimitError as any).status = 429
        ;(rateLimitError as any).error = errorDetails.error
        throw rateLimitError
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }
    }
    return await response.json()
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}

export const postData = async (endpoint, data) => {
  const auth = useAuthStore()
  const apiUrl = import.meta.env.VITE_API_BASE_URL
  try {
    const response = await fetch(`${apiUrl}/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    if (!response.ok) {
      if (response.status === 400) {
        throw new Error('Bad Request: Please check your input.')
      } else if (response.status === 401) {
        throw new Error('Unauthorized: Please log in.')
      } else if (response.status === 409) {
        throw new Error('User already registered')
      } else if (response.status === 403) {
        auth.updateLoginIssue('User activation approval pending.')
      } else {
        throw new Error(data.message || 'An error occurred')
      }
    }
    return await response.json()
  } catch (error) {
    console.error('Error posting data:', error)
    throw error
  }
}

export const postDataAuth = async (endpoint, data) => {
  const apiUrl = import.meta.env.VITE_API_BASE_URL
  const auth = useAuthStore()
  try {
    const response = await fetch(`${apiUrl}/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${auth.token}`,
      },
      body: JSON.stringify(data),
    })
    if (!response.ok) {
      if (response.status === 400) {
        throw new Error('Bad Request: Please check your input.')
      } else if (response.status === 401) {
        throw new Error('Unauthorized: Please log in.')
      } else if (response.status === 208) {
        // return await { status: false, message: 'You can only set alert for 10 domains' }
        throw new Error('You can only set alert for 10 domains')
      } else {
        throw new Error(data.message || 'An error occurred')
      }
    }
    return await response.json()
  } catch (error) {
    console.error('Error posting data:', error)
    throw error
  }
}

// const patchData =
export const patchData = async (endpoint, data) => {
  const apiUrl = import.meta.env.VITE_API_BASE_URL
  const auth = useAuthStore()
  try {
    const response = await fetch(`${apiUrl}/${endpoint}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${auth.token}`,
      },
      body: JSON.stringify(data),
    })
    if (!response.ok) {
      if (response.status === 400) {
        throw new Error('Bad Request: Please check your input.')
      } else if (response.status === 401) {
        throw new Error('Unauthorized: Please log in.')
      } else {
        throw new Error(data.message || 'An error occurred')
      }
    }
    return await response.json()
  } catch (error) {
    console.error('Error posting data:', error)
    throw error
  }
}
